
(function() {
  if (!window.location.pathname.match(/\/blogs\//)) return;
  
  var debounceTimer = null;
  var isEN = window.location.pathname.indexOf('/en/') === 0;
  var i18n = isEN
    ? { placeholder: 'Search all guides...', searching: 'Searching...', hits: ' results', noResults: 'No guides found.', error: 'Search error.', of: ' of ' }
    : { placeholder: 'Alle Guides durchsuchen...', searching: 'Suche...', hits: ' Treffer', noResults: 'Keine Guides gefunden.', error: 'Fehler bei der Suche.', of: ' von ' };
  
  function init() {
    var articles = document.querySelectorAll('.blog-articles__article');
    if (!articles.length) return;
    
    var container = document.querySelector('.blog-articles');
    if (!container) return;
    
    // Build search bar
    var wrapper = document.createElement('div');
    wrapper.id = 'ak-blog-search';
    wrapper.style.cssText = 'max-width:680px;margin:0 auto 2rem;padding:0 1rem;position:relative;';
    
    var input = document.createElement('input');
    input.type = 'text';
    input.placeholder = i18n.placeholder;
    input.id = 'ak-blog-search-input';
    input.style.cssText = 'width:100%;padding:12px 44px 12px 18px;font-size:15px;font-family:Jost,sans-serif;border:1px solid #d0d0d0;border-radius:6px;background:#fff;color:#1a1a1a;outline:none;transition:border-color .2s;box-sizing:border-box;';
    
    // Search icon (SVG)
    var icon = document.createElement('span');
    icon.innerHTML = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#999" stroke-width="2" style="position:absolute;right:30px;top:50%;transform:translateY(-50%);pointer-events:none;"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
    icon.style.cssText = 'position:absolute;right:0;top:0;height:100%;display:flex;align-items:center;';
    
    input.addEventListener('focus', function() { this.style.borderColor = '#3D4A5B'; });
    input.addEventListener('blur', function() { this.style.borderColor = '#d0d0d0'; });
    
    // Results container (for API results, shown below the existing grid)
    var resultsBox = document.createElement('div');
    resultsBox.id = 'ak-blog-search-results';
    resultsBox.style.cssText = 'display:none;';
    
    // Counter
    var counter = document.createElement('div');
    counter.id = 'ak-blog-search-counter';
    counter.style.cssText = 'font-size:13px;color:#888;margin-top:6px;font-family:Jost,sans-serif;text-align:right;min-height:18px;';
    
    wrapper.appendChild(input);
    wrapper.appendChild(icon);
    wrapper.appendChild(counter);
    
    // Insert before blog-articles grid
    var title = document.querySelector('.title--primary');
    if (title && title.parentNode) {
      title.parentNode.insertBefore(wrapper, container);
      title.parentNode.insertBefore(resultsBox, container.nextSibling);
    } else {
      container.parentNode.insertBefore(wrapper, container);
      container.parentNode.insertBefore(resultsBox, container.nextSibling);
    }
    
    // Pagination element
    var pagination = document.querySelector('.pagination-wrapper');
    
    function showDefault() {
      container.style.display = '';
      if (pagination) pagination.style.display = '';
      resultsBox.style.display = 'none';
      resultsBox.innerHTML = '';
      counter.textContent = '';
    }
    
    function renderResults(articleResults) {
      container.style.display = 'none';
      if (pagination) pagination.style.display = 'none';
      resultsBox.style.display = '';
      
      if (articleResults.length === 0) {
        resultsBox.innerHTML = '<div style="text-align:center;padding:3rem 1rem;color:#888;font-family:Jost,sans-serif;font-size:15px;">' + i18n.noResults + '</div>';
        counter.textContent = '0' + i18n.hits;
        return;
      }
      
      counter.textContent = articleResults.length + i18n.hits;
      
      var html = '<div class="blog-articles" style="display:grid;grid-template-columns:repeat(2,1fr);gap:2rem;padding:0 0 2rem;">';
      articleResults.forEach(function(a) {
        var imgHtml = '';
        if (a.image) {
          imgHtml = '<div style="aspect-ratio:1;overflow:hidden;border-radius:4px 4px 0 0;"><img src="' + a.image + '" alt="' + (a.title || '').replace(/"/g, '&quot;') + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;"></div>';
        }
        html += '<a href="' + a.url + '" style="text-decoration:none;color:inherit;display:block;background:#fff;border-radius:4px;overflow:hidden;box-shadow:0 1px 3px rgba(0,0,0,.08);transition:box-shadow .2s;" onmouseover="this.style.boxShadow=\'0 4px 12px rgba(0,0,0,.12)\'" onmouseout="this.style.boxShadow=\'0 1px 3px rgba(0,0,0,.08)\'">';
        html += imgHtml;
        html += '<div style="padding:1rem 1.2rem;">';
        html += '<h3 style="margin:0 0 .5rem;font-size:16px;font-family:\'DM Sans\',sans-serif;font-weight:500;color:#1a1a1a;line-height:1.3;">' + a.title + '</h3>';
        if (a.body) {
          var cleanStr = a.body.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
                               .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
                               .replace(/<[^>]+>/g, '')
                               .replace(/\s+/g, ' ')
                               .trim();
          var excerpt = cleanStr.substring(0, 140);
          html += '<p style="margin:0;font-size:13px;color:#666;line-height:1.5;font-family:Jost,sans-serif;">' + excerpt + '...</p>';
        }
        html += '</div></a>';
      });
      html += '</div>';
      resultsBox.innerHTML = html;
    }
    
    function doSearch(query) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=article&resources[limit]=20&resources[options][fields]=title,body,tag';
      
      fetch(url)
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var results = [];
          if (data.resources && data.resources.results && data.resources.results.articles) {
            data.resources.results.articles.forEach(function(a) {
              results.push({
                title: a.title,
                url: a.url,
                body: a.body || '',
                image: a.image || (a.featured_image ? a.featured_image.url : null)
              });
            });
          }
          renderResults(results);
        })
        .catch(function(err) {
          console.error('Blog search error:', err);
          resultsBox.innerHTML = '<div style="text-align:center;padding:2rem;color:#c00;font-family:Jost,sans-serif;">' + i18n.error + '</div>';
        });
    }
    
    // Live search with debounce
    input.addEventListener('input', function() {
      var q = this.value.trim();
      
      clearTimeout(debounceTimer);
      
      if (!q) {
        showDefault();
        return;
      }
      
      if (q.length < 2) return;
      
      counter.textContent = i18n.searching;
      debounceTimer = setTimeout(function() {
        doSearch(q);
      }, 300);
    });
    
    // Clear on Escape
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        this.value = '';
        showDefault();
        this.blur();
      }
    });
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
